import { containsKey } from "./contains-key";

export function isTires(category?: string) {
  if (!category) {
    return false;
  }

  return containsKey(category, ["tires", "pneus"]);
}
